import * as React from 'react'

import { CheckIcon, MinusIcon, XIcon, type LucideIcon } from 'lucide-react'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import ILocationTransferPair from '~/client/src/shared/models/ILocationTransferPair'

interface IProps {
  transferPairs: ILocationTransferPair[]
  plannedDeliveryLocationId: string
  plannedInstallLocationId: string
  iconElement: JSX.Element
}

const DEFAULT_ICON_SIZE = 16

@observer
export default class CurrentLocationStatusIcon extends React.Component<IProps> {
  public static defaultProps = {
    transferPairs: [],
  }

  public render() {
    if (this.isTransfering) {
      return this.props.iconElement
    }

    const StatusIcon = this.statusIcon

    return (
      <StatusIcon
        size={DEFAULT_ICON_SIZE}
        className={classList({
          'mx5 text': true,
          'success-green': this.isInstallIcon,
          yellow: !this.isInstallIcon && this.isDeliveryIcon,
          red: !this.isInstallIcon && !this.isDeliveryIcon,
        })}
      />
    )
  }

  private get isTransfering(): boolean {
    return this.props.transferPairs.some(p => p.materialTransfers.length)
  }

  private get isInstallIcon(): boolean {
    const {
      transferPairs,
      plannedDeliveryLocationId,
      plannedInstallLocationId,
    } = this.props
    return (
      (!plannedInstallLocationId && !plannedDeliveryLocationId) ||
      transferPairs.every(tp => tp.location.id === plannedInstallLocationId)
    )
  }

  private get isDeliveryIcon(): boolean {
    const {
      transferPairs,
      plannedDeliveryLocationId,
      plannedInstallLocationId,
    } = this.props

    if (!plannedDeliveryLocationId) {
      return true
    }
    if (plannedInstallLocationId) {
      return transferPairs.every(
        tp =>
          tp.location.id === plannedDeliveryLocationId ||
          tp.location.id === plannedInstallLocationId,
      )
    }
    return transferPairs.every(
      tp => tp.location.id === plannedDeliveryLocationId,
    )
  }

  private get statusIcon(): LucideIcon {
    if (this.isInstallIcon) {
      return CheckIcon
    }
    if (this.isDeliveryIcon) {
      return MinusIcon
    }
    return XIcon
  }
}
